import { ErrorHandler, inject, provideAppInitializer } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { SentryErrorHandlerWithFailedChunkReload } from '../error-tracking/sentry-error-handler-with-failed-chunk-reload';

const errorHandler = new SentryErrorHandlerWithFailedChunkReload();

export function provideSentry() {
  return [
    {
      provide: ErrorHandler,
      useValue: errorHandler,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ];
}
